import React, { Fragment } from "react";
import ReactDOM from "react-dom";
import classes from "./TooltipMenu.module.css";

const Backdrop = (props) => {
  return <div className={classes.backdrop} onClick={props.onClick} />;
};
const TooltipOverlay = (props) => {
  return <div className={classes.tolti_menu}>{props.children}</div>;
};
const TooltipMenu = (props) => {
  const portalElement = document.getElementById("overlays");
  return (
    <Fragment>
      {ReactDOM.createPortal(
        <Backdrop onClick={props.onClose} />,
        portalElement
      )}
      <TooltipOverlay>{props.children}</TooltipOverlay>
    </Fragment>
  );
};

export default TooltipMenu;
